import * as pdfjs from 'pdfjs-dist';

import { configurePdfJsWorker } from '@/products/maintenance/features/pdf/configure-pdfjs-worker';

/**
 * Loads a maintenance PDF through our cookie session, then hands bytes to pdf.js.
 * Using `url` + `withCredentials` inside pdf.js is brittle when the API answers with JSON errors.
 */
export async function loadMaintenancePdfDocument(url: string): Promise<pdfjs.PDFDocumentProxy> {
  await configurePdfJsWorker();
  const response = await fetch(url, { credentials: 'include' });
  if (!response.ok) {
    throw new Error(`PDF-Anfrage fehlgeschlagen (${response.status}).`);
  }
  const contentType = response.headers.get('content-type') ?? '';
  if (contentType.includes('application/json')) {
    throw new Error('Keine PDF-Quelldatei für dieses Protokoll.');
  }
  const data = new Uint8Array(await response.arrayBuffer());
  if (data.byteLength < 5 || !isPdfHeader(data)) {
    throw new Error('Die Antwort ist keine gültige PDF-Datei.');
  }
  const task = pdfjs.getDocument({ data });
  return task.promise;
}

function isPdfHeader(data: Uint8Array): boolean {
  return data[0] === 0x25 && data[1] === 0x50 && data[2] === 0x44 && data[3] === 0x46;
}
